import React, { createContext, useContext } from 'react'
import PropTypes from 'prop-types'
import { useAppContext } from '../../../../redux/slices/appContext'
import ActiveDDPInspectorProvider from './ActiveDDPInspectorProvider'

const noop = () => {}
const noopContextValue = {
  isActive: false,
  register: noop,
  unregister: noop,
  entries: [],
  openDrawerFor: noop,
  closeDrawer: noop,
  activeEntryId: null,
  setComponentAccessors: noop,
  clearComponentAccessors: noop,
  componentAccessorsByEntryId: {}
}

const DDPInspectorContext = createContext(noopContextValue)

export default DDPInspectorContext

export function useDDPInspectorContext () {
  return useContext(DDPInspectorContext)
}

// Always renders ActiveDDPInspectorProvider so the wrapper element type stays
// stable across the `isSummitUser` undefined → true transition (otherwise the
// children subtree, including AppInitializer, would remount on first load).
// ActiveDDPInspectorProvider gates all UI/registration on `isActive`.
//
// Mirrors the backend `danger_zone` policy (summitOnly + advisor + all
// accounts access) so users who would get a 403 from `debug-data-pipeline`
// don't see the launcher.
export function DDPInspectorProvider ({ children }) {
  const { isSummitUser, isAdvisor, userProfile } = useAppContext()
  const isActive = !!(isSummitUser && isAdvisor && userProfile?.allAccountsAccess)
  return <ActiveDDPInspectorProvider isActive={isActive}>{children}</ActiveDDPInspectorProvider>
}

DDPInspectorProvider.propTypes = {
  children: PropTypes.node
}
